import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../../utils/styles';
import './typography-body.scss';

export interface ITypographyBodyComponent {
  text: string;
  typographyClass: string;
  className?: string[];
}

const TypograpyBodyComponent: React.FC<ITypographyBodyComponent> = ({
  text = '',
  typographyClass = '',
  className = [],
}) => <p className={styles(typographyClass, ...className)}>{text}</p>;

TypograpyBodyComponent.propTypes = {
  text: PropTypes.string.isRequired,
  typographyClass: PropTypes.string.isRequired,
};

export default TypograpyBodyComponent;
